import LandingLayout from './landing';
import WebLayout from './web';
import DownloadLayout from './download';
import BlogLayout from './blog';

export { LandingLayout, WebLayout, DownloadLayout, BlogLayout };
